module.exports = __webpack_public_path__ + "static/media/dmt_report.2741fd5c.svg";